import styled from "styled-components";

export const HomeContainer = styled.div`
  overflow-x: hidden;
  position: relative;
  /* background-image: linear-gradient(0deg, #222, #272727); */
`

export const MoviesContainer = styled.div`
  background-image: linear-gradient(100deg, #000, #252525, #000);
  padding-bottom: 50px;
  overflow: hidden;
`